import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  CampaignSearchCategory,
  CampaignSearchSchema,
  Country,
} from '../models/campaign-search.model';

export const getMasterData = createAction('[Campaign Search]: Master Data Init');

export const getCategoriesSuccess = createAction(
  '[Campaign Search]: Get Categories Success',
  props<{ categories: CampaignSearchCategory[] }>(),
);

export const getCategoriesFail = createAction(
  '[Campaign Search]: Get Categories Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const getSchemasSuccess = createAction(
  '[Campaign Search]: Get Schemas Success',
  props<{ schemas: CampaignSearchSchema[] }>(),
);
export const getSchemasFail = createAction(
  '[Campaign Search]: Get Schemas Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const getStaticDataSuccess = createAction(
  '[Campaign Search]: Get Static Data Success',
  props<{ staticData: any }>(),
);
export const getStaticDataFail = createAction(
  '[Campaign Search]: Get Static Data Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const getCountriesSuccess = createAction(
  '[Campaign Search]: Get Countries Success',
  props<{ countries: Country[] }>(),
);

export const getCountriesFail = createAction(
  '[Campaign Search]: Get Countries Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const SearchPanelChanged = createAction('[Campaign Search]: Search panel Changed');

export const BasicFiltersPanelChanged = createAction(
  '[Campaign Search]: Basic Filters panel Changed',
);

export const AdvancedFiltersPanelChanged = createAction(
  '[Campaign Search]: Advanced Filters  panel Changed',
);

export const NameChanged = createAction(
  '[Campaign Search]: Name Changed',
  props<{ campaignName: string }>(),
);

export const CategoryChanged = createAction(
  '[Campaign Search]: Category Changed',
  props<{ campaignCategoryId: number }>(),
);

export const NotesChanged = createAction(
  '[Campaign Search]: Notes Changed',
  props<{ notes: string }>(),
);

export const DescriptionChanged = createAction(
  '[Campaign Search]: Description Changed',
  props<{ description: string }>(),
);

export const StatusChanged = createAction(
  '[Campaign Search]: Status Changed',
  props<{ campaignStatus: string }>(),
);

export const TargetGroupChanged = createAction(
  '[Campaign Search]: TargetGroup Changed',
  props<{ campaignSelectionTarget: string }>(),
);

export const SchemaChanged = createAction(
  '[Campaign Search]: Schema Changed',
  props<{ loyaltySchemaId: number }>(),
);

export const ChannelChanged = createAction(
  '[Campaign Search]: Channel Changed',
  props<{ campaignChannel: string }>(),
);

export const ActiveCampaignsChanged = createAction(
  '[Campaign Search]: ActiveCampaigns Changed',
  props<{ deactivated: boolean }>(),
);
export const DeletedCampaignsChanged = createAction(
  '[Campaign Search]: DeletedCampaigns Changed',
  props<{ deleted: boolean }>(),
);
export const MyCampaignsChanged = createAction(
  '[Campaign Search]: MyCampaigns Changed',
  props<{ user: boolean }>(),
);

export const ActiveFromStartDateChanged = createAction(
  '[Campaign Search]: ActiveFromStartDateChanged Changed',
  props<{ activeDateFromStartDate: string }>(),
);
export const ActiveFromEndDateChanged = createAction(
  '[Campaign Search]: ActiveFromEndDateChanged Changed',
  props<{ activeDateFromEndDate: string }>(),
);

export const ActiveUntilStartDateChanged = createAction(
  '[Campaign Search]: ActiveUntilStartDateChanged Changed',
  props<{ activeDateUntilStartDate: string }>(),
);
export const ActiveUntilEndDateChanged = createAction(
  '[Campaign Search]: ActiveUntilEndDateChanged Changed',
  props<{ activeDateUntilEndDate: string }>(),
);

export const DateTypeChanged = createAction(
  '[Campaign Search]: Date Type Changed',
  props<{ dateSector: string; dateType: string }>(),
);
export const UseTimeChanged = createAction(
  '[Campaign Search]: Use Time Changed',
  props<{ dateSector: string; useTime: boolean }>(),
);

export const ClearDateField = createAction(
  '[Campaign Search]: Clear Date Field',
  props<{ dateField: string }>(),
);

export const ClearSearchFields = createAction('[Campaign Search]: Clear All Fields');

export const CampaignSearchCount = createAction('[Campaign Search]: Search Count');

export const CampaignSearchCountFailed = createAction(
  '[Campaign Search]: Search Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenCampaignSendModal = createAction(
  '[Campaign Search]: Open Campaign Send Modal',
  props<{ campaign: any }>(),
);

export const OpenCampaignNotesModal = createAction(
  '[Campaign Search]: Open Campaign Notes Modal',
  props<{ notes: string }>(),
);

export const OpenCampaignDuplicateModal = createAction(
  '[Campaign Search]: Open Campaign Duplicate Modal',
  props<{ campaign: any }>(),
);

export const VerificationInputChanged = createAction(
  '[Campaign Search]: Verification Input Changed',
  props<{ verificationInput: string }>(),
);

export const SendCampaign = createAction('[Campaign Search]: Send Campaign');

export const SendCampaignSuccess = createAction('[Campaign Search]: Send Campaign Success');

export const SendCampaignFail = createAction('[Campaign Search]: Send Campaign Fail');

export const CloseSendCampaignModal = createAction('[Campaign Search]: Close Send Campaign Modal');

export const CloseCampaignNotesModal = createAction(
  '[Campaign Search]: Close Campaign Notes Modal',
);

export const CloseCampaignDuplicateModal = createAction(
  '[Campaign Search]: Close Campaign Duplicate Modal',
);

export const DuplicateCampaignNameChanged = createAction(
  '[Campaign Search]: Duplicate Campaign Name Changed',
  props<{ duplicateCampaignName: string }>(),
);

export const OriginalCampaignDeactivationChanged = createAction(
  '[Campaign Search]: Original Campaign Activation Changed',
  props<{ originalCampaignDeactivation: boolean }>(),
);

export const CopyCampaignInit = createAction('[Campaign Search]: Copy Campaign Init');

export const CopyCampaignSuccess = createAction('[Campaign Search]: Copy Campaign Success');

export const CopyCampaignFail = createAction(
  '[Campaign Search]: Copy Campaign Fail',
  props<{ error: HttpErrorResponse; errorMessage?: string }>(),
);

export const OpenCampaignDeactivationModal = createAction(
  '[Campaign Search]: Open Deactivation Modal',
  props<{ campaign: any }>(),
);

export const ActivateCampaignInit = createAction(
  '[Campaign Search]: Activate Campaign Init',
  props<{ campaign: any }>(),
);

export const ActivateCampaignSuccess = createAction('[Campaign Search]: Activate Campaign Success');

export const ActivateCampaignFail = createAction('[Campaign Search]: Activate Campaign Fail');

export const DeactivateCampaignInit = createAction('[Campaign Search]: Deactivate Campaign Init');

export const DeactivateCampaignSuccess = createAction(
  '[Campaign Search]: Deactivate Campaign Success',
);

export const DeactivateCampaignFail = createAction('[Campaign Search]: Deactivate Campaign Fail');

export const EditCampaignInit = createAction(
  '[Campaign Search]: Campaign Update Init',
  props<{ row: any }>(),
);

export const EditCampaignSuccess = createAction(
  '[Campaign Search]: Campaign Update Success',
  props<{ campaign: any }>(),
);

export const EditCampaignFailure = createAction(
  '[Campaign Search]: Campaign Update Failure',
  props<{ error: HttpErrorResponse }>(),
);
